import http from './http';

export default {
  sharedAssets() {
    return http().get(`/v1/shareable_groups/shared_assets`);
  },
  installSharedAsset(sharedAsset, validationErrors = {}) {
    return http(validationErrors).post(`/v1/shareable_groups/shared_assets`, sharedAsset);
  },
  
  all() {
    return http().get(`/v1/shareable_groups`);
  },
  create(data) {
    return http().post(`/v1/shareable_groups`, data);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/shareable_groups/${data.id}`, data);
  },
  updateSharedAssets(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/shareable_groups/${data.id}/shared_assets`, data);
  },
  delete(id) {
    return http().delete(`/v1/shareable_groups/${id}`);
  },
}
